<p-card>

      <div class="grid">
          <div class="col-12 md:col-12 lg:col-12 breadcrumbrightmenu flex align-items-right">
              <div class="flex align-items-right" style="margin-left: auto;margin-right: 0;">
                <button pButton style="padding: 0.35rem !important;" type="button" icon="fa fa-plus" class="dataplus p-button-sm p-button-raised mr-4" 
                    pTooltip="Add Signatory Data" tooltipPosition="bottom" (click)="show('Add Signatory Data','')"></button>
                  <!-- <p-menu #menu [model]="items" [popup]="true" appendTo="body"></p-menu>
                  <app-sdlcmenu></app-sdlcmenu> -->
                  <button pTooltip="Help" tooltipPosition="left" class="fa fa-question helpicon"
                  (click)="helpservice.openhelpmodal(ref, dialogService, 'Help', 13)">
                  </button>
              </div>
          </div>
      </div>
    
  
    <div class="mr-0" *ngIf="signatorylistarray.length>0">
    
    <p-table 
      #dt 
      [value]="signatorylistarray" 
      [rows]="rows2"
      [scrollable]="true" 
      scrollDirection="horizontal" 
      scrollHeight="{{commonScrollHeight}}"
      [globalFilterFields]="['rid','usertypeflag','name','email','mobno','createdon','createdby','status']"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" sortField="reporteddate"
      [rowsPerPageOptions]="paginatorArray" 
      dataKey="id" 
      [resizableColumns]="true"
      columnResizeMode="expand"    
      sortField="name"
      [rowHover]="true" 
      [showCurrentPageReport]="true"
      paginatorLocale="fa-IR" 
      [paginator]="signatorylistarray.length>10" 
      (sortFunction)="customSort($event)" 
      [customSort]="true"
      [sortOrder]="1" responsiveLayout="scroll"
      (onPage)="handlePageChange($event)">
      <!-- search -->
 
        <ng-template pTemplate="caption">
          <div class="grid table-header1 ">
              <div class="col-12 sm:col-8 md:col-8 sm:col-12">
                <span class=" p-input-icon-lft"><i icon="pi pi-search"></i>
                    <input class="form-control" pInputText type="text" id="tablesearch"
                    (input)="dt.filterGlobal($any($event.target).value , 'contains'); searchTerm = $any($event.target).value;"
                    placeholder="Search in Signatories"
                    class="tablesearch" pTooltip="Enter Search Criteria" tooltipPosition="top" />
                </span>
              </div>
              <div class="col-12 sm:col-2 md:col-2 sm:col-12 ">
                  <div class="iconexcel" pTooltip="Download Data" tooltipPosition="bottom" style="cursor: pointer;"
                (click)="exceDownloadModel();"></div>
              </div>
              </div>
            </ng-template>


    <ng-template pTemplate="header" >
      <tr>
        <th pResizableColumn style="padding-left: 15px !important;">Action </th>
        <ng-container *ngFor="let col of _selectedColumns">
            <th pResizableColumn [pSortableColumn]="col.fieldname" *ngIf="col.ischecked">{{col.headername}}
                <p-sortIcon [field]="col.fieldname"></p-sortIcon>
            </th>
        </ng-container>
    </tr>
    </ng-template>
  
    <ng-template pTemplate="body" let-data>
      <tr>
      <td style="width: 10px !important;">
        <div style="display: flex; gap: 0px;">
         <span class="actionItm" pTooltip="Modify" tooltipPosition="left"> <i class="fa fa-edit"
         (click)="show('Modify Signatory Data',data)"></i></span>
         </div>
       </td>
      <ng-container *ngFor="let col of _selectedColumns">
      <td *ngIf="col.ischecked" [style.width]="col.width" [class]="col.class">
        <span *ngIf="col.fieldname!=='activeflag'" pTooltip=" {{data[col.fieldname] }}"  [innerHTML]="highlight(data[col.fieldname],searchTerm)"></span>
        <span *ngIf="col.fieldname=='activeflag'">
          <i *ngIf="data[col.fieldname]=== 'Y'" pTooltip="Active" tooltipPosition="left" class="fa fa-flag"
           style="color: green;"></i>
          <i *ngIf="data[col.fieldname]!== 'Y'" pTooltip="Not Active" tooltipPosition="left" class="fa fa-flag"
           style="color: red;"></i>
        </span>
      </td>
      </ng-container>
      </tr>
     </ng-template>
     </p-table>
     </div>
     <div class="card" style="margin-top: -4px;" *ngIf="signatorylistarray.length==0">
     <p-card>
       <p style="text-align: center;">There is no Data in the Signatory Master...</p>
     </p-card>
    </div>
    </p-card>
      
    <p-dialog header="Excel Download" [(visible)]="exceldownloadModal" [modal]="true" [baseZIndex]="10000"
      [draggable]="true" [resizable]="false" position="top">
      <div class="dialog-content-min-excel" style=" text-align: center !important;">
        <div class="card">
          <p>{{excel_paragraph}}</p>
        </div>
      </div>
    
      <div class="custom-dialog-footer">
        <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="exceldownloadModal=false"></p-button>
      </div>
    </p-dialog>
    
  